module.exports = __webpack_public_path__ + "static/img/43.cad97a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/43.png
// module id = VS3p
// module chunks = 1